import React from "react";
import GeneralStrings from "../../../strings/GeneralStrings.json";
import { ErrorMessage, Field } from "formik";
import { validateRequired } from "../../../utilities/ValidationHelper";

const StartDateStep = () => {
  const START_DATE_STEP_STRINGS =
    GeneralStrings.ENROLL.FORM_LABELS.START_DATE_STEP;

  return (
    <div className="step">
      <h4 className="step-header">{START_DATE_STEP_STRINGS.HEADER}</h4>
      <div className="question-container">
        <div className="form-group">
          <Field
            name="startDate"
            type="date"
            className="form-control"
            validate={validateRequired}
          />
          <ErrorMessage
            component="span"
            className="form-error"
            name="startDate"
          />
        </div>
      </div>
    </div>
  );
};

export default StartDateStep;
